import { useShrinkContext } from "../context/ShrinkContext";

export default function ShrinkButton() {
  const [state, dispatch] = useShrinkContext();
  return (
    <div
      className={state.shrink ? "shrink-button" : "shrink-button-active"}
      onClick={() => dispatch({ type: "toggleShrink" })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
        className={
          state.shrink
            ? "w-3 h-auto effect-transition"
            : "w-3 h-auto rotate-180 effect-transition"
        }
      >
        {/* <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --> */}
        <path
          d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
          fill="1e293b"
        />
      </svg>
    </div>
  );
}
